import * as c from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { ProfileUserIcon } from 'src/assets/icons/nav/profile-user.icon'
import { useAuth } from 'src/pages/auth/auth-context'

const Header = () => {
  const { isAuth, user } = useAuth()
  const { t } = useTranslation(['components/nav', 'profile'])

  return (
    <c.Flex
      width="100%"
      height="140px"
      bg="primary.500"
      borderBottomRadius="16px"
      pt="l3"
      pb="m8"
      px="s5"
    >
      {isAuth ? (
        <c.Flex alignItems="center" gap="s6">
          <c.Avatar />
          <c.Box>
            <c.Heading color="black.0" fontSize="h-sm.0" fontWeight="medium">
              {t('profile:HELLO')}
            </c.Heading>
            <c.Heading
              color="black.0"
              fontWeight="bold"
              fontSize="h-md.0"
              textTransform="capitalize"
            >
              {user?.firstName}
            </c.Heading>
          </c.Box>
        </c.Flex>
      ) : (
        <c.Flex alignItems="center" gap="s6">
          <c.Avatar
            h="67px"
            w="67px"
            bg="black.200"
            icon={
              <c.Icon
                as={ProfileUserIcon}
                w="1.75rem"
                h="1.75rem"
                color="black.0"
              />
            }
          />

          <c.Heading color="black.0" fontWeight="bold" fontSize="h-md.0">
            {t('components/nav:LOGIN_ACCOUNT')}
          </c.Heading>
        </c.Flex>
      )}
    </c.Flex>
  )
}

export default Header
